import React, { useState } from "react";
import FormFieldsLayout from "../ContactForms/common/FormBox";
import NumberFormat from "react-number-format";
import { unformatPhoneNumber } from "../../utils/text";
import { Button } from "../Buttons";
import { Input, Box, Checkbox, useToast } from "@chakra-ui/core";
import axios from "axios";

import "./style.css";

const CustomPhoneInput = React.forwardRef(({ value, ...props }: any, ref: any) => (
  <Input
    {...props}
    ref={ref}
    value={value}
    color={value ? "black" : "gray.500"}
    _placeholder={{ color: "gray.500" }}
  />
));
CustomPhoneInput.displayName = "CustomPhoneInput";

export default function SpecialistForm({topBike}: {topBike:string}) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    topBike
  });

  const [formSubmitted, setFormSubmitted] = useState(false);

  const toast = useToast();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handlePhoneChange = (values: any) => {
    setFormData((prev) => ({
      ...prev,
      phone: values.formattedValue,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      await axios.post("/.netlify/functions/contactSpecialist", formData);
      toast({
        title: "Success",
        description: "Form submitted successfully.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      setFormData({
        name: "",
        email: "",
        phone: "",
        topBike
      });
      setFormSubmitted(true);
    } catch (error) {
      console.error("Submission error:", error);
      toast({
        title: "Error",
        description: "Something went wrong.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Box as="form" onSubmit={handleSubmit} className="spealist_form-container">
      <FormFieldsLayout className="spealist_form-fields_group" mb="2.9531rem">
        {!formSubmitted ? (
          <>
            <Box className="row">
              <Input
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
              />
            </Box>
            <Box className="row">
              <Input
                name="email"
                placeholder="Email address"
                type="email"
                isRequired
                value={formData.email}
                onChange={handleChange}
              />
            </Box>
            <Box className="row">
              <NumberFormat
                name="phone"
                type="tel"
                format="(###) ###-####"
                allowEmptyFormatting
                mask="_"
                placeholder="Phone"
                value={formData.phone}
                onValueChange={handlePhoneChange}
                customInput={CustomPhoneInput}
              />
            </Box>

            <Box className="row" textAlign="center">
              <Button theme="primary" type="submit">
                Submit
              </Button>
            </Box>
          </>
        ) : (
          <p>Our fitting specialist will call you soon!</p>
        )
      }
      </FormFieldsLayout>
    </Box>
  );
}
